import CardBtnV2 from 'assets/Icons/cardBtnV2';
import CashBtnV2 from 'assets/Icons/cashBtnV2';
import EPayBtnV2 from 'assets/Icons/epayBtnV2';
import GiftCardBtnV2 from 'assets/Icons/giftCardBtnV2';
import IcDollar from 'assets/Icons/IcDollar';
import IcFeeV2 from 'assets/Icons/IcFee';
import IcMoney from 'assets/Icons/IcMoney';
import IcPayment from 'assets/Icons/IcPayment';
import IcTotal from 'assets/Icons/IcTotal';
import LoyaltyPointBtnV2 from 'assets/Icons/loyaltyPointBtnV2';
import Tip from 'assets/Icons/tip';
import Box from 'components/Box';
import Text from 'components/Text';
import ticketListSelectors from 'features/ticketList/services/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

const SummaryClosedTicket = () => {
  const summaryData = ticketListSelectors.summaryTickets();
  const summaryPaymentType = ticketListSelectors.summaryPaymentType();
  return (
    <Container>
      <SummaryIncome>
        <StatisticItem
          label='Total Sales'
          value={formatCurrency(summaryData?.subTotal || 0)}
          icon={<IcMoney width={80} height={80} />}
        />
        <StatisticItem
          label='Taxes'
          value={formatCurrency(summaryData?.totalTax || 0)}
          icon={<IcDollar width={80} height={80} />}
        />
        <StatisticDiscountItem
          discount={formatCurrency(summaryData?.discount || 0)}
          staffDiscount={formatCurrency(summaryData?.staffDiscount || 0)}
          cashDiscount={formatCurrency(summaryData?.cashDiscount || 0)}
        />
        <StatisticItem
          label='Tips'
          value={formatCurrency(summaryData?.tip || 0)}
          icon={<Tip width={80} height={80} fill='#346751' />}
        />
        <StatisticItem
          label='Card Fees'
          value={formatCurrency(summaryData?.feeCreditCard || 0)}
          icon={<IcFeeV2 width={80} height={80} fill='#4B63C7' />}
        />
        <StatisticItem
          label='Total'
          value={formatCurrency(summaryData?.total || 0)}
          icon={<IcTotal width={80} height={80} fill='#DA072D' />}
        />
      </SummaryIncome>
      <SummaryPaymentType>
        <PaymentTypeItem
          label='Cash'
          value={formatCurrency(summaryPaymentType?.cashAmount || 0)}
          icon={<CashBtnV2 width={32} height={32} fill='#C84B31' />}
          bgColor='#FFF1F6'
        />
        <PaymentTypeItem
          label='Redeem Points'
          value={formatCurrency(summaryPaymentType?.pointAmount || 0)}
          icon={<LoyaltyPointBtnV2 width={32} height={32} fill='#EBA33B' />}
          bgColor='#FFFDED'
        />
        <PaymentTypeItem
          label='Credit Card'
          value={formatCurrency(summaryPaymentType?.creditCardAmount || 0)}
          icon={<CardBtnV2 width={32} height={32} fill='#2D6772' />}
          bgColor='#E4F4F6'
        />
        <PaymentTypeItem
          label='Check'
          value={formatCurrency(summaryPaymentType?.checkAmount || 0)}
          icon={<EPayBtnV2 width={32} height={32} fill='#C52884' />}
          bgColor='#FFEAF6'
        />
        <PaymentTypeItem
          label='Redeem Gift Card'
          value={formatCurrency(summaryPaymentType?.giftCardAmount || 0)}
          icon={<GiftCardBtnV2 width={32} height={32} fill='#2563EB' />}
          bgColor='#EEF4FF'
        />
        <PaymentTypeItem
          label='Others'
          value={formatCurrency(summaryPaymentType?.otherAmount || 0)}
          icon={<IcPayment width={32} height={32} fill='#9747FF' />}
          bgColor='#F1EFFF'
        />
      </SummaryPaymentType>
    </Container>
  );
};

export default SummaryClosedTicket;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
  font-family: Poppins;
`;

const SummaryIncome = styled.div`
  grid-column: span 8;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
`;

const SummaryPaymentType = styled.div`
  grid-column: span 4;
  border-radius: 8px;
  border: 1px solid #e9edf2;
  background: #fff;
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.15);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 12px 16px;
  column-gap: 12px;
`;

interface IStatisticItemProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
}

const StatisticItem = ({ label, value, icon }: IStatisticItemProps) => {
  return (
    <ContainerStatistic>
      <Box display='flex' flexDirection='column' justifyContent='space-between' height='100%'>
        <Text variant='H9' color='text_4_v2'>
          {label}
        </Text>
        <Text variant='H3'>{value}</Text>
      </Box>
      {icon}
    </ContainerStatistic>
  );
};

const ContainerStatistic = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #ccd4dc;
  background: #fff;
`;

interface IPaymentTypeItemProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  bgColor?: string;
}

const PaymentTypeItem = ({ label, value, icon, bgColor }: IPaymentTypeItemProps) => {
  return (
    <ContainerPaymentType>
      <Box display='flex' gap='2' alignItems='center'>
        <Box className='box-icon' style={{ backgroundColor: bgColor || '#F6F7FC' }}>
          {icon}
        </Box>
        <Text variant='H9'>{label}</Text>
      </Box>
      <Text variant='H5'>{value}</Text>
    </ContainerPaymentType>
  );
};

const ContainerPaymentType = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box-icon {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }

  &:nth-child(odd) {
    border-right: 1px solid #e9edf2;
    padding-right: 16px;
  }
`;

interface DiscountItemProps {
  discount: string;
  staffDiscount: string;
  cashDiscount: string;
}

const StatisticDiscountItem = ({ discount, staffDiscount, cashDiscount }: DiscountItemProps) => {
  return (
    <DiscountItemStyled>
      <div className='content'>
        <Text variant='H9' color='text_4_v2'>
          Discounts
        </Text>
        <Text variant='H3'>{discount}</Text>
      </div>
      <div className='deduction-item'>
        <div className='staff-item'>
          <Text variant='CONTENT_2' color='v2_blue_3' textAlign='start'>
            Staff:{' '}
          </Text>
          <Text variant='H7' color='v2_orange_2' textAlign='end'>
            {staffDiscount}
          </Text>
        </div>
        <div className='owner-item'>
          <Text variant='CONTENT_2' color='v2_blue_3' textAlign='start'>
            Owner:{' '}
          </Text>
          <Text variant='H7' color='v2_orange_2' textAlign='end'>
            {cashDiscount}
          </Text>
        </div>
      </div>
    </DiscountItemStyled>
  );
};

const DiscountItemStyled = styled.div`
  display: flex;
  gap: 16px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #ccd4dc;
  background: #fff;
  position: relative;
  grid-template-columns: 1fr 1fr;

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 12px 0 12px 16px;
  }

  .deduction-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background-color: #f6f7fc;
    padding: 8px 0;
    border-radius: 0 8px 8px 0;

    .staff-item,
    .owner-item {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 24px;
      padding: 0 12px;
    }

    .staff-item {
      border-bottom: 1px solid #ccd4dc;
    }
  }
`;
